<template>
   <div id="tablog">
       <div v-for="(data,i) in dataLog" v-bind:key="data.id">
           <div class="d-flex flex-row mt-1 ml-2">
                <div class="linhaAling">
                    <div class="ballCrzy" :id="i == 0 ?  'greenChange' : ''">
                        <div class="textNum">{{data.diaFormat}}</div>
                        <div class="textNum">{{data.mesFormat}}</div>
                    </div>
                    <div class="linhaSolid" :id="i == 0 ?  'greenChange' : ''"></div>
                </div>
                <div class ="ml-3 mt-3">
                    <div class="squareCrzy">
                        <div class=Textneg :id="i == 0 ?  'greenChange' : ''"> Tabela de Preços atualizada</div>
                        <div class=Textneg2>
                            <i class="far fa-clock">  {{data.dataFormat}} |</i>
                            <i class="fas fa-user-circle"> {{data.conta.nome}}</i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default{
  props: ['dataLog']
}

</script>

<style scoped>

#greenChange {
    color: #008148;
}

.ballCrzy {
    width: 50px;
    height: 50px;
    border-radius:50%;
    border: 3px solid;
}

.squareCrzy {
    width: 500px;
    height: 110px;
    background: rgb(243, 241, 241);
    border-radius:1px 40px 40px;
    color: #111;
}

.textNum{
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
}

.Textneg2 {
    padding-left: 25px;
    font-size: 12px;
    color:rgb(116, 121, 116);
}

.Textneg {
    font-weight: bold;
    padding: 24px;
    font-size: 15px;
    color:rgb(104, 104, 104);
}

.linhaSolid {
    height: 125px;
    border-left: 2px solid;
}

.linhaAling{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
}

#tablog{
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/pricetablemanagement/components/compLog/compLog.vue